export default __webpack_public_path__ + "4ba5df874bcd062dab5d74ce99923d9f.svg";